export * from './getAppName';
